import axiosClient from '../axiosClient';
import { ENTITY_RESOURCES_API_URL } from '../constants';

const ResourceEntity = {
  createResource: async (body: any) => {
    try {
      const response = await axiosClient.post(`${ENTITY_RESOURCES_API_URL}`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },

  createResourceWithUpload: async (body: any) => {
    try {
      //Add formData
      const response = await axiosClient.post(`${ENTITY_RESOURCES_API_URL}/upload`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },

  fetchResources: async (params: any) => {
    try {
      const response = await axiosClient.get(ENTITY_RESOURCES_API_URL, { params });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },

  deleteResource: async (params: any) => {
    try {
      const response = await axiosClient.delete(ENTITY_RESOURCES_API_URL, { params });
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },

  uploadResources: async (body: FormData) => {
    try {
      const response = await axiosClient.post(`${ENTITY_RESOURCES_API_URL}/upload`, body, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },

  updateResourceDetails: async (body: any) => {
    try {
      const response = await axiosClient.put(`${ENTITY_RESOURCES_API_URL}`, body);
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
};

export default ResourceEntity;
